import { Observable } from "rxjs";
import { ExecutionStates } from "@focus/interfaces/lib/program/ProgramExecution";
import { StompActionskeys } from "../stomp-broker/index";
const idToConfig = (programId) => {
    return Object.assign({}, programId);
};
const mapFromActions = (actions) => (msg) => {
    switch (msg.type) {
        case ExecutionStates.EXECUTION_ERROR:
            return [actions.setError(idToConfig(msg.payload), "cannot run program")];
        case ExecutionStates.EXECUTION_STARTED:
            return [actions.setPending(idToConfig(msg.payload))];
        case ExecutionStates.EXECUTION_FINISHED:
            return [actions.setResponse(idToConfig(msg.payload), null)];
        default:
            return [];
    }
};
export function createSubcriptionEpic(url, actions) {
    const mapMsg2Action = mapFromActions(actions);
    return (actions$, __, { stomp }) => actions$.ofType(StompActionskeys.CONNECTED).mergeMap(() => stomp
        .subscribe(url)
        .mergeMap((msg) => Observable.of(...mapMsg2Action(msg)))
        .takeUntil(actions$.ofType(StompActionskeys.DISCONNECTED).take(1)));
}
//# sourceMappingURL=subscription.js.map